import { ref } from 'vue';
import { defineStore } from 'pinia';

/**
 * Text typed in the home search bar. Shared between the bar, which stays
 * mounted over the map, and the results panel the search route opens under it.
 */
export const useSearchStore = defineStore('search', () => {
  const query = ref<string>('');

  function reset() {
    query.value = '';
  }

  return { query, reset };
});
